import {ofType} from 'redux-observable';
import {concat, iif, of, mergeMap, EMPTY} from 'rxjs';
import {delay} from 'rxjs/operators';
import {AnyAction} from 'redux';
import * as UIActions from '../actions/UIActions';
import * as WizardMXActions from '../actions/WizardMXActions';

export const onSelectStepEpic = (action$, state$) =>
    action$.pipe(
        ofType(UIActions.ON_SELECT_STEP_ACTION.name),
        delay(500), // TODO research saga / thunks para no usar delay
        mergeMap((action: AnyAction) => {
            let actionToExec = {type: ''};
            switch (action.step) {
                case '0':
                    actionToExec = WizardMXActions.GO_TO_CALCULATOR_MX_ACTION.action();
                    break;
                case '1':
                    actionToExec = WizardMXActions.GO_TO_APPLICANT_DATA_MX_ACTION.action();
                    break;
                case '3':
                    actionToExec = WizardMXActions.GO_TO_APPLICANT_DOMICILE_MX_ACTION.action();
                    break;
                case '4':
                    actionToExec = WizardMXActions.GO_TO_PRIVACY_BUREAU_TERMS_MX_ACTION.action();
                    break;
                case '5':
                    actionToExec = WizardMXActions.GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION.action();
                    break;
                case '6':
                    actionToExec = WizardMXActions.GO_TO_OTHER_REFERENCES_MX_ACTION.action();
                    break;
                case '7':
                    actionToExec = WizardMXActions.GO_TO_INSURANCES_MX_ACTION.action();
                    break;
                case '8':
                    actionToExec = WizardMXActions.GO_TO_FILES_UPLOAD_MX_ACTION.action();
                    break;
                default:
                    break;
            }
            return concat(
                iif(
                    () => action.shouldRedirect,
                    of(actionToExec),
                    EMPTY
                ),
                of(UIActions.ON_SELECTED_STEP_ACTION.action(action.step, action.highestStep))
            );
        })
    );
